import type { Course, Maybe } from '@edwin-group/people-graphql';
import LessonCard from '@/components/Learn/Lesson';
import SubContainer from '@/components/Container/SubContainer';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export type courseWithLearnProps = Course & { learn?: { completed?: boolean; learnCount?: number } };

function CardCourseGroupedByCategory({
  category,
}: {
  category: {
    name: string;
    description: string;
    courses: (Maybe<courseWithLearnProps> | undefined)[];
  };
}) {
  return (
    <SubContainer className="col-span-12 min-w-0">
      <div className="flex min-w-0 flex-col gap-sh-30 md:flex-row md:flex-wrap">
        {category?.courses?.map((course) => {
          const lessonsCount =
            course?.modules?.reduce((acc, curr) => {
              return acc + (curr?.lessons || [])?.length || 0;
            }, 0) || 1;

          return (
            <AnimatedFadeInComponent key={course!.title!}>
              <div className="w-full min-w-0 md:w-auto">
                <LessonCard
                  title={course!.title}
                  description={course!.description}
                  thumbnail={course!.thumbnail}
                  url={`/learn/course/${course?.slug}`}
                  key={course!.title!}
                  tag="Course"
                  duration={course?.duration || ''}
                  watchLabel="Continue"
                  progress={course?.learn?.completed ? 100 : ((course?.learn?.learnCount || 1) / lessonsCount) * 100}
                  done={course?.learn?.completed}
                />
              </div>
            </AnimatedFadeInComponent>
          );
        })}
      </div>
    </SubContainer>
  );
}

export default CardCourseGroupedByCategory;
